import BaseDeCalculoAccordion from 'components/baseDeCalculoAccordion/baseDeCalculoAccordion';
import { ArrecadacaoContext } from 'contexts/ArrecadacaoContext';
import { useNotificacao } from 'hooks/useNotificacao';
import { NomesPaginasOutrosRegimes, PaginasOutrosRegimes } from 'interfaces/IBasesCalculo';
import { IOutrasBasesNcmReceber } from 'interfaces/IOutrasBases';
import { useBackEndRequests } from 'pages/TitularArrendatario/lib/backEndRequests';
import React, { useContext } from 'react';
import NcmAccordion from '../ncmAccordion/ncmAccordion';
import styles from './listaOutrasBases.module.scss';

interface IListaOutrasBasesProps {
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes | ''>>;
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  baseCalculo: IOutrasBasesNcmReceber[];
  idBaseCalculo: number;
  tipoBaseCalculo: PaginasOutrosRegimes;
  refetchLista: () => void;
  setIsAdicaoNovaBaseCalculo: React.Dispatch<React.SetStateAction<boolean>>;
  isViewOnly: boolean | undefined;
}

const ListaOutrasBases = ({
  setBaseDeCalculo,
  setIsEdicao,
  baseCalculo,
  idBaseCalculo,
  tipoBaseCalculo,
  refetchLista,
  setIsAdicaoNovaBaseCalculo,
  isViewOnly,
}: IListaOutrasBasesProps) => {
  let contador = 0;

  const { deleteOutrasBasesCalculo } = useBackEndRequests();

  const context = useContext(ArrecadacaoContext);

  const mostrarNotificacao = useNotificacao();

  const editarBaseCalculo = () => {
    setBaseDeCalculo(tipoBaseCalculo);
    setIsAdicaoNovaBaseCalculo(true);
    setIsEdicao(true);
    context?.setIdOutrosRegimes(idBaseCalculo);
  };

  const excluirBaseCalculo = async () => {
    await deleteOutrasBasesCalculo(idBaseCalculo)
      .then(() => {
        mostrarNotificacao({
          tipo: 'success',
          conteudo: 'Base de Cálculo excluída com sucesso',
        });

        refetchLista();
      })
      .catch((err) => {
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Erro ao excluir a base de cálculo, tente novamente mais tarde. Erro: ' + err.message,
        });
      });
  };

  return (
    <BaseDeCalculoAccordion
      title={NomesPaginasOutrosRegimes[tipoBaseCalculo]}
      deleteFunction={() => excluirBaseCalculo()}
      isNCM={false}
      isEditable={!isViewOnly}
      editFunction={() => editarBaseCalculo()}
    >
      <div className={styles.ncmsContainer}>
        {baseCalculo?.map((item: IOutrasBasesNcmReceber) => {
          contador++;
          return <NcmAccordion isEditable={false} ncm={item} key={contador} tipoBaseCalculo={tipoBaseCalculo} />;
        })}
      </div>
    </BaseDeCalculoAccordion>
  );
};

export default ListaOutrasBases;
